import React from 'react'
import HelperText from './HelperText';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    ref?: React.RefObject<HTMLInputElement>;
    type?: 'text' | 'password' | 'email' | 'number' | 'tel' | 'url' | 'file' | 'color';
    label?: string;
    helperText?: string;
    error?: boolean;
    endIcon?: React.ReactNode;
    required?: boolean;
    endIconClickable?: boolean;
    componentBelow?: React.ReactNode;
}

const StandardTextInput = (props: Props) => {
    const { endIcon, endIconClickable, error, helperText, componentBelow, ...rest } = props;
    function getColors() {
        if (props.disabled) {
            return `bg-utility-muted`;
        }
        if (error) {
            return `bg-neutral-deep text-primary-dark ring-red-400 ring-2 focus:ring-error`;
        }
        return `bg-neutral-deep text-primary-dark placeholder:text-neutral-dark focus:ring-primary-light focus:ring-2`;
    }

    function getLabelColor() {
        if (props.color) {
            return `text-${props.color}`;
        }
        return 'text-primary-dark';
    }

    function getEndIconClickableClass() {
        if (endIconClickable) {
            return 'cursor-pointer';
        }
        return 'pointer-events-none';
    }

    function getInputRightPadding() {
        if (props.endIcon == null) {
            return "pr-[12px]";;
        }
        return "pr-[50px]";
    }

    return (
        <div>
            <label className={`${getLabelColor()} block font-bold text-[16px] mb-2`}>
                {props.label}{props.required && <span> *</span>}
            </label>
            <div className='relative'>
                <input
                    className={`${getColors()} w-full box-border rounded-[12px] shadow-sm py-[12px] pl-[16px] ${getInputRightPadding()} font-bold text-[16px] leading-6 placeholder:font-medium ${props.type === 'color' ? 'h-[50px]' : ''}`}
                    type={props.type || 'text'}
                    style={{
                        outline: 'none',
                    }}
                    {...rest}
                />
                {endIcon && (
                    <div className={`absolute right-4 transform text-primary-light top-[10px] ${getEndIconClickableClass()}`}>
                        {endIcon}
                    </div>
                )}
            </div>
            <HelperText error={error}>
                {helperText}
            </HelperText>
            {componentBelow && (componentBelow)}
        </div>
    )
}

export default StandardTextInput